import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';
import { CardDetailsProps } from './CardDetails.types';

// Config
import cardDetailsState from './CardDetails.state';
import paymentTypeConstants from '../../../constants/paymentTypeConstants';
import { triggerUseSavedCardAnalytics } from '../../../redux/actions/payment/cardPaymentActions';

// Components
import { BillingDetails } from './billing-details';
import CreditCardForm from './credit-card-form/CreditCardForm';
import Container from '@components/container';
import PrepaidCardMessage from '../../prepaid-card-message';
import SaveAsDefaultForm from '../../save-as-default-form/SaveAsDefaultForm';
import ThreeDSecureWarning from '../../three-d-secure-warning';

// Styles
import styles from './card-details.scss';

const CardDetails = ({
  disabled = false,
  isNewCard = false,
  prepaidCard = false,
  resetAfterError,
}: CardDetailsProps) => {
  const dispatch: AppDispatch = useDispatch();
  const { canSave } = useSelector(state => cardDetailsState(state, prepaidCard));

  const onSaveCardChange = (value: boolean) => {
    dispatch(triggerUseSavedCardAnalytics(value));
  };

  return (
    <div className={styles.container}>
      <Container marginBottom="3">{prepaidCard ? <PrepaidCardMessage /> : <ThreeDSecureWarning />}</Container>

      <CreditCardForm disabled={disabled} prepaidCard={prepaidCard} resetAfterError={resetAfterError} />

      <BillingDetails disabled={disabled} />

      {isNewCard && canSave && (
        <SaveAsDefaultForm
          onChange={onSaveCardChange}
          saveAsDefaultObject={{ default: false }}
          type={paymentTypeConstants.CREDIT_CARD}
        />
      )}
    </div>
  );
};

export default memo(CardDetails);
